import ClipText from "@components/ClipText/ClipText";
import Image from "@components/Image";
import cx from "classnames";
import React from "react";
import styles from "./OtherRooms.module.scss";
import Button from "@components/Button";
import { useTranslationContext } from "@providers/TranslationProvider";
import { useRouteContext } from "@providers/RouteProvider";
import { useBookingContext } from "@providers/BookingProvider";
import _ from "lodash";
import { usePageContext } from "@providers/PageProvider";
interface Props {
  data: {
    slug: string;
    image: {
      src: string;
      alt: string;
    };
    title: string;
  };
  className: string | { [key: string]: string };
}

export default function Item({ data, className }: Props) {
  const { i18n } = useTranslationContext();
  const { router } = useRouteContext();
  const { booking } = useBookingContext();
  const { hotel } = usePageContext();
  const handler = {
    to: (room: any) => {
      router.push("room-detail", { slug: _.get(room, "slug") });
    },
    book: (_room: any) => {
      booking.open({ hotel });
    },
  };

  return (
    <div className={cx(styles.item, className)}>
      <Image
        wrapperProps={{ className: cx(styles.image) }}
        src={data.image.src}
        alt={data.image.alt}
        layout="fill"
        objectFit="cover"
      />
      <ClipText className={cx(styles.title)}>{data.title}</ClipText>
      <div className={cx(styles.btnGroup)}>
        <Button
          type="text"
          className={styles.viewRoomBtn}
          onClick={() => {
            handler.to(data);
          }}
          label={i18n.t("Button.viewThisRoom")}
        />
        <Button
          className={styles.bookRoomBtn}
          onClick={() => {
            handler.book(data);
          }}
          label={
            <>
              <span className="xs:hidden sm:block">
                {i18n.t("Button.bookThisRoom")}
              </span>
              <span className="xs:block sm:hidden">
                {i18n.t("Button.bookNow")}
              </span>
            </>
          }
        />
      </div>
    </div>
  );
}
